import { get, post, del, put } from '@elementary/common-ui/utils/http';
import { TeamUser } from 'shared/types';
import {
  CreateRoleRequest,
  UpdateRoleRequest,
  Role,
  RoleResponse,
} from './types';

export const fetchRoles = (): Promise<Role[]> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/account/roles`);

export const fetchRole = (roleId: string): Promise<RoleResponse> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/account/roles/${roleId}`);

export const createRole = (data: CreateRoleRequest): Promise<RoleResponse> =>
  post(`${import.meta.env.VITE_API_BASE_URL}/account/roles`, data);

export const updateRole = (
  roleId: string,
  data: UpdateRoleRequest,
): Promise<RoleResponse> =>
  put(`${import.meta.env.VITE_API_BASE_URL}/account/roles/${roleId}`, data);

export const deleteRole = (roleId: string): Promise<void> =>
  del(`${import.meta.env.VITE_API_BASE_URL}/account/roles/${roleId}`);

export const fetchRoleUsers = (roleId: string): Promise<TeamUser[]> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/account/roles/${roleId}/users`);
